import { ContactDetailsComponentData } from '@boels/models';
import { of } from 'rxjs';

export const ContactDetailsComponentDataMock: ContactDetailsComponentData = {
  title: 'Direct contact',
  subtitle2:
    'Heeft u vragen over het openen van uw Boels-rekening? We helpen u graag!',
  tinyText: 'Maandag t/m vrijdag 07:00 uur – 17:00 uur',
  phoneNumber: '0900-0551',
  phoneRate: '(lokaal tarief)',
  facebookLink: 'https://facebook.com',
  twitterLink: 'https://twitter.com',
  showDivider: false,
  emailAddress: 'boels@hotmail.com',
  button: {
    url: 'www.google.com',
    target: '_blank',
    linkName: 'Neem contact op',
  },
};

export const ContactDetailsComponentDataMockQA = {
  data$: of({
    uid: 'cmsitem_00202022',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMjAyMDIyIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'ContactDetailsComponent',
    modifiedtime: '2022-12-01T16:12:47.66+01:00',
    name: 'Contact D QA',
    container: false,
    subtitle2: "Let's test this #2",
    subtitle1: "Let's test this #1",
    title: "Let's test this: QA Title",
    facebookLink: 'cypressQA@io.com',
    button: {
      container: false,
      contentPage: 'cmsitem_00024030',
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDI0MDM2IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      contentPageLabelOrId: '/bouwmaatpas',
      linkName: 'Renting on account',
      url: '/QA_test_url',
      typeCode: 'CMSLinkComponent',
      target: false,
      uid: 'cmsitem_00024036',
      external: true,
      name: 'Huren op rekening - Link',
      synchronizationBlocked: 'false',
      parents: 'cmsitem_00193004 cmsitem_00193010 cmsitem_00202022',
    },
    tinyText: "Let's test this Tiny text",
    showDivider: false,
    emailAddress: 'cypressQA@io.com',
    children: 'cmsitem_00024036',
    synchronizationBlocked: 'false',
  }),
};
